module.exports = "/_next/static/images/24b31d195b07c16e4a2cec37de37c016-email-icon.svg.webp";